import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Currency from './Currency'

const DisplayPoints = ({
  hasDiscount,
  hasCashback,
  regularPrice,
  price,
  currency,
  pointCash
}) => (
  <Fragment>
    {hasDiscount && (
      <div className='card-price-from col-12 txt-subtitle txt-font-body color-ui-2 txt-left'>
        De <s>{regularPrice}</s> pts por
      </div>
    )}
    <div
      className='card-price-points col-12 txt-title txt-font-body txt-left color-ui-1 nowrap'
      title=''
    >
      <Currency value={price} {...currency} />
    </div>
    {pointCash && (
      <div className='card-price-complete-with col-12 txt-body-sm txt-font-body txt-left txt-bold color-success'>
        <div className='row'>
          <div className='col-12 pt-half'>Ou utilize reales + dinheiro</div>
        </div>
      </div>
    )}
    {hasCashback && (
      <div className='card-price-cashback col-auto mx-1 txt-body-sm txt-font-body txt-left txt-bold color-success border border-color-ui-4 radius'>
        <div className='row'>
          <div className='col-auto px-0 d-none d-lg-block'>
            <i className='icon_cashback icon-sm icon icon_gift color-success' />
          </div>
          <div className='col-auto txt-body-sm'>
            Ganhe <Currency value={Math.floor(0.05 * price)} {...currency} />
          </div>
        </div>
      </div>
    )}
  </Fragment>
)

DisplayPoints.propTypes = {
  hasDiscount: PropTypes.bool,
  regularPrice: PropTypes.number,
  price: PropTypes.number.isRequired,
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  pointCash: PropTypes.object,
  hasCashback: PropTypes.bool
}

export default DisplayPoints



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductAvailability/PriceLabel/DisplayPoints.js